export enum HapiUIIconType {
	solid = "solid",
	regular = "regular",
	light = "light",
	thin = "thin",
	duotone = "duotone",
	vonq = "vonq",
	lottie = "lottie",
}
